<template>
  <div class="ai-visibility-reading-legend">
    <span class="ai-visibility-reading-legend__label">Reading this page:</span>
    <status-legend-item
      v-for="item in items"
      :key="item.status || item.key"
      :status="item.status || item.key"
      :label="item.label"
    />
  </div>
</template>

<script>
import StatusLegendItem from '../ui/display/StatusLegendItem.vue'

export default {
  name: 'ReadingLegend',
  components: {
    StatusLegendItem,
  },
  props: {
    items: {
      type: Array,
      default () {
        return [
          { key: 'great', label: 'Doing great' },
          { key: 'improve', label: 'Room to improve' },
          { key: 'attention', label: 'Needs attention' },
          { key: 'new', label: 'New this week' },
        ]
      },
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-reading-legend {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  border: 1px solid var(--v-gray13Color-base);
  border-radius: 999px;
  color: var(--v-mainColor3-base);
  font-size: 14px;
  margin-top: 22px;
  padding: 9px 14px;

  span {
    font-size: 14px;
  }
}

.ai-visibility-reading-legend__label {
  color: #363636;
  font-weight: 700;
}

@media (max-width: 620px) {
  .ai-visibility-reading-legend {
    align-items: flex-start;
    border-radius: 8px;
    flex-direction: column;
  }
}
</style>
